import { render, staticRenderFns } from "./ends.vue?vue&type=template&id=25b1e0ff&"
import script from "./ends.vue?vue&type=script&lang=js&"
export * from "./ends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports